/* =====================================================================
   Stockpinturas · Mejoras de la ficha de producto
   1. Accesibilidad de los desplegables (aria-controls, foco, teclado)
   2. Etiqueta de ahorro sincronizada con la variante seleccionada
   3. Barra fija de compra en móvil (opcional)
   No sustituye a ningún script del tema: solo añade atributos y nodos propios.
   ===================================================================== */
(function () {
  'use strict';

  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.4l4.4 4.4L19 7.2"/></svg>';

  /* ---------------------------------------------- Desplegables ----- */
  function enhanceAccordions(root) {
    var summaries = root.querySelectorAll(
      '.product__accordion summary, .product_accordion summary'
    );
    Array.prototype.forEach.call(summaries, function (summary) {
      if (summary.dataset.spReady) return;
      summary.dataset.spReady = '1';

      var wrapper = summary.parentElement;
      var content = wrapper && wrapper.querySelector('.accordion__content');
      var insideDetails = wrapper && wrapper.tagName === 'DETAILS';

      if (content) {
        if (!content.id) content.id = 'sp-acc-' + Math.random().toString(36).slice(2, 9);
        summary.setAttribute('aria-controls', content.id);
      }

      // El tema pinta <summary> fuera de <details> en los bloques webi-collapse.
      // Ahí el navegador no lo hace focusable, así que lo añadimos nosotros.
      if (!insideDetails) {
        if (!summary.hasAttribute('tabindex')) summary.setAttribute('tabindex', '0');
        if (!summary.hasAttribute('role')) summary.setAttribute('role', 'button');
        if (!summary.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', 'false');
        summary.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            summary.click();
          }
        });
      }
    });
  }

  /* ------------------------------------------------- Ahorro -------- */
  function readData(section) {
    var node = section.querySelector('script.sp-pdp-data');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function currentVariantId(section) {
    var input = section.querySelector('.product-variant-id')
      || section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? String(input.value || '') : '';
  }

  function renderSaving(section, data) {
    if (!data || !data.variants) return;
    var priceEl = section.querySelector('.sp-buycard [id^="price-"]')
      || section.querySelector('[id^="price-"]');
    if (!priceEl) return;

    var old = section.querySelector('.sp-saving');
    if (old) old.parentNode.removeChild(old);

    var pair = data.variants[currentVariantId(section)];
    if (!pair) return;

    var diff = (pair[1] - pair[0]) / 100;
    var pct = Math.round(((pair[1] - pair[0]) / pair[1]) * 100);
    if (!(diff > 0) || !(pct > 0)) return;

    var money;
    try {
      money = new Intl.NumberFormat(data.locale || undefined, {
        style: 'currency', currency: data.currency || 'EUR'
      }).format(diff);
    } catch (e) {
      money = diff.toFixed(2);
    }

    var pill = document.createElement('span');
    pill.className = 'sp-saving';
    pill.innerHTML = CHECK + ' ' + (data.label || 'Ahorras') + ' ' + money + ' (' + pct + '%)';

    // Se inserta DENTRO de la fila del precio (.price__sale), no como hermana
    // del contenedor. Como hermana quedaba en su propia línea porque el tema
    // le da width:100% al contenedor del precio.
    var row = priceEl.querySelector('.price__sale')
      || priceEl.querySelector('.price__regular')
      || priceEl;
    row.appendChild(pill);
  }

  /* ------------------------------------------ Barra fija móvil ----- */
  function initStickyBuy(section) {
    var bar = section.querySelector('.sp-stickybuy');
    var submit = section.querySelector('.product-form__submit');
    if (!bar || !submit || !('IntersectionObserver' in window)) return;

    var barBtn = bar.querySelector('.sp-stickybuy__btn');
    var barPrice = bar.querySelector('.sp-stickybuy__price');

    function sync() {
      var live = section.querySelector('.product-form__submit');
      if (live && barBtn) {
        barBtn.disabled = live.disabled;
        var label = live.querySelector('span');
        if (label) barBtn.textContent = label.textContent.trim();
      }
      var priceEl = section.querySelector('[id^="price-"]');
      if (barPrice && priceEl) {
        var current = priceEl.querySelector('.price__sale .price-item--sale')
          || priceEl.querySelector('.price__regular .price-item--regular');
        if (current) barPrice.textContent = current.textContent.trim();
      }
    }

    sync();

    if (barBtn) {
      barBtn.addEventListener('click', function () {
        var live = section.querySelector('.product-form__submit');
        if (live && !live.disabled) live.click();
      });
    }

    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(submit);

    section.addEventListener('sp:refresh', sync);
  }

  /* --------------------------------------------------- Arranque ---- */
  function setup(section) {
    var data = readData(section);
    enhanceAccordions(section);
    renderSaving(section, data);
    if (section.classList.contains('sp-has-sticky')) initStickyBuy(section);

    if (section.dataset.spObserved) return;
    section.dataset.spObserved = '1';

    // El precio, el stock y el botón se re-renderizan al cambiar de variante.
    var host = section.querySelector('product-info') || section;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        enhanceAccordions(section);
        renderSaving(section, data);
        section.dispatchEvent(new CustomEvent('sp:refresh'));
      }, 60);
    }).observe(host, { childList: true, subtree: true });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.sp-pdp'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
